import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AddInvoiceManually from './add-invoice-manually';
import UploadInvoiceModal from './upload-invoice-modal';
import './add-invoice.scss';
import { Plus } from 'react-bootstrap-icons';

const AddInvoiceModal: React.FC = () => {
   const [showUploadModal, setShowUploadModal] = useState<boolean>(false);
   const [showOptionModal, setShowOptionModal] = useState<boolean>(false);
   const [showManualForm, setShowManualForm] = useState<boolean>(false);
   const { t } = useTranslation(['common']);

   return (
      <>
         <Button
            className="custom-width primary"
            onClick={() => setShowOptionModal(true)}
         >
            {t('common:settings.addInvoice')} <Plus size={24} />
         </Button>

         <Modal show={showOptionModal} onHide={() => setShowOptionModal(false)} centered>
            <Modal.Header closeButton>
               <Modal.Title>{t('common:settings.addInvoice')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center modal-selection">
               <Button
                  className="w-100 outline-primary"
                  onClick={() => {
                     setShowManualForm(true);
                     setShowOptionModal(false);
                  }}
               >
                  {t('common:common.manually')}
               </Button>
               <Button
                  className="w-100 primary"
                  onClick={() => {
                     setShowUploadModal(true);
                     setShowOptionModal(false);
                  }}
               >
                  {t('common:common.upload')}
               </Button>
            </Modal.Body>
         </Modal>

         <UploadInvoiceModal
            open={showUploadModal}
            onClose={() => setShowUploadModal(false)}
         />

         <AddInvoiceManually
            open={showManualForm}
            onClose={() => setShowManualForm(false)}
         />
      </>
   );
};

export default AddInvoiceModal;
